<template>
    <a :href="href" class="dropdown-item" @click.prevent="$emit('click', $event)">
        <slot />
    </a>
</template>

<script setup>
defineProps({
    href: {
        type: [String, undefined],
        default: () => '#',
    },
});

defineEmits(['click']);
</script>
